const VALID_PORTAL_ROLES = new Set(["client", "expert", "platform"]);

// 当前项目15位修改版本：202610176312000。
// 紧凑值只用于前端项目内识别，不是独立 Git 构建版本；独立 Git 构建版本请读取根目录 git_build_version.txt。
// 中文维护注释：机器编号从实际执行电脑未提交的machine.conf读取，项目编号12必须拼入版本号。
export const PROJECT_CHANGE_VERSION = "202610176312000";

// 本地开发固定使用三组端口，生产环境可通过 Vite 环境变量覆盖完整地址。
export const PORTAL_PORTS = {
  client: 5201,
  expert: 5202,
  platform: 5203,
};

// 构建 mode 优先，便于通过 vite --mode 直接生成对应角色的门户。
export const PORTAL_ROLE = VALID_PORTAL_ROLES.has(import.meta.env.MODE)
  ? import.meta.env.MODE
  : VALID_PORTAL_ROLES.has(import.meta.env.VITE_PORTAL_ROLE)
    ? import.meta.env.VITE_PORTAL_ROLE
    : "client";

const configuredUrls = {
  client: import.meta.env.VITE_CLIENT_PORTAL_URL,
  expert: import.meta.env.VITE_EXPERT_PORTAL_URL,
  platform: import.meta.env.VITE_PLATFORM_PORTAL_URL,
};

export function portalUrl(role) {
  if (!VALID_PORTAL_ROLES.has(role)) return "";
  if (configuredUrls[role]) return configuredUrls[role];
  if (typeof window === "undefined") return "";

  const url = new URL(window.location.href);
  url.port = String(PORTAL_PORTS[role]);
  url.pathname = "/";
  url.search = "";
  url.hash = "";
  return url.toString();
}
